// extracted by mini-css-extract-plugin
export default {"intro":"Quote_intro__eekem"};